/**
 * Created by Victor Rojo on 18/2/20.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import {SurveillanceCamera} from "./SurveillanceCamera";

@Injectable()
export class SurveillanceService{

  private basePath = "api/v1/camera";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(): Promise<any>{
    let url = this.basePath;
    return this.http.get(url)
      .toPromise()
      .then( res => res as SurveillanceCamera[])
      .catch( error => this.errorHandler(error) );
  }

}
